export const TAPPING_DONE_REQUEST = "TAPPING_DONE_REQUEST";
export const TAPPING_DONE_SUCCESS = "TAPPING_DONE_SUCCESS";
export const TAPPING_DONE_FAILED = "TAPPING_DONE_FAILED";